'use strict';

// handleResume re-establishes session liveness when the app returns to the
// foreground (visibilitychange / pageshow / online).
//
// After a sleep the access token may have lapsed, and the SSE connection is
// often a zombie: the browser still reports it open while the server saw its
// heartbeat write fail minutes ago. Without this hook all of that is repaired
// lazily at the user's first tap — dead-socket discovery, then a single-flight
// refresh gating the whole request fan-out — which is exactly the random
// "10s+ tab switch" stall. Doing it at wake instead means the first tap finds
// a fresh token and a warm connection.
//
// Order matters: refresh first — a successful tryRefresh reconnects SSE itself
// (api.js calls window.__reconnectSSE), so reconnecting here too would open a
// second stream. Reconnect directly only when no refresh ran (token still
// fresh) or the refresh failed (token may still be valid on a flaky network).
//
// Dependencies are injected so the decision is unit-testable without a browser.
export async function handleResume({ hasToken, tokenStale, tryRefresh, sseAlive, reconnect }) {
  if (!hasToken()) return; // logged out — nothing to restore
  if (tokenStale()) {
    const refreshed = await tryRefresh();
    if (refreshed) return; // refresh already reconnected SSE
  }
  if (!sseAlive()) reconnect();
}
